import type { ReactNode } from 'react';

import { useAuthContext } from '../../context';
import { Navigate } from '../components';

export const PlatformGuard = ({ children }: { children: ReactNode }) => {
  const { currentUser } = useAuthContext();

  if (!currentUser?.isPlatformUser) {
    return <Navigate replace to="/" />;
  }

  return children;
};
